import { createApi } from "@reduxjs/toolkit/query/react";
import { reservationAxiosQuery } from "../../utils/axios/reservation.axios";
import {
  ICustomExperienceAssistant,
  IHotels,
} from "../../interfaces/customer-experience-assistant/ICustomExperienceAssistant";
import { IProfile } from "../../interfaces/customer-experience-assistant/IProfile";

export const customerExperienceAPI = createApi({
  reducerPath: "customerExperience",
  baseQuery: reservationAxiosQuery(),
  tagTypes: ["customerExperience"],
  endpoints: (builder) => ({
    getCustomerExperienceAssistant: builder.mutation<
      ICustomExperienceAssistant,
      {
        hotelName: string,
        userId: string,
        locationId: string,
      }
    >({
      query: (data) => ({
        url: `/hotel-reports/generate`,
        method: "POST",
		data
      }),
    }),
	getCustomerExperienceAssistantManual: builder.mutation<
      ICustomExperienceAssistant,
      {
        userId: string,
        locationId: string,
      }
    >({
      query: (data) => ({
        url: `/hotel-reports/reviews`,
        method: "POST",
		data
      }),
    }),
    getHotelList: builder.query<IHotels[], string>({
      query: (userId) => ({
        url: `/hotel-location/by-user/${userId}`,
        method: "GET",
      }),
	  providesTags: ['customerExperience']
    }),
	createHotelLocation: builder.mutation<void, IProfile>({
		query: (data) => ({
		  url: `/hotel-location/create`,
		  method: "POST",
		  data
		}),
		invalidatesTags: ['customerExperience']
	  }),
  }),
});

export const {
  useGetCustomerExperienceAssistantMutation,
  useGetCustomerExperienceAssistantManualMutation,
  useGetHotelListQuery,
  useCreateHotelLocationMutation
} = customerExperienceAPI;
